export const tableWrapperStyles = {
  padding: 0,

  '& .table-cell__content_box': {
    overflow: 'visible',
  },
};

export const emptyMessageCellStyles = {
  padding: 0,
  '& .table-cell__content_box': {
    padding: '8px !important',
    height: 'unset !important',
  },
};

export const editActionStyles = {
  display: 'flex',
  gap: '4px',
  justifyContent: 'center',
};
